import React from 'react';
import { getImagePath } from './utils/getImagePath';
export default function PluginLogo({ imageName }) {
    const imagePath = getImagePath(imageName);
    return React.createElement("img", { src: imagePath, style: { height: '36px' } });
}
